import React from "react";
import { Link } from "react-router-dom";
import { siteContent } from "../../../constants/site";
import { SocialIcon } from "./SocialIcon";

export const Footer: React.FC = () => {
  const handleFooterNavigate = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="bg-background-footer text-accent-footerText">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-6 lg:gap-8 items-start">
          <div className="space-y-4 md:col-span-5">
            <p className="text-sm leading-relaxed text-accent-footerText">
              {siteContent.footer.tagline}
            </p>
            <div className="flex space-x-4">
              {siteContent.footer.socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.url}
                  className="text-accent-footerText hover:opacity-80 hover:-translate-y-0.5 transition-all duration-200 motion-reduce:transform-none"
                  aria-label={social.platform}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <SocialIcon platform={social.platform} />
                </a>
              ))}
            </div>
          </div>
          <div className="md:col-span-2">
            <ul className="space-y-2">
              {siteContent.footer.links.about.map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.path}
                    onClick={handleFooterNavigate}
                    className="text-accent-footerText hover:opacity-80 transition-opacity duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-2">
            <ul className="space-y-2">
              {siteContent.footer.links.contact.map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.path}
                    onClick={handleFooterNavigate}
                    className="text-accent-footerText hover:opacity-80 transition-opacity duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="space-y-3 md:col-span-3">
            <div className="flex items-start space-x-2">
              <svg
                className="w-5 h-5 mt-0.5 flex-shrink-0"
                fill="currentColor"
                viewBox="0 0 20 20"
                style={{ color: "#B8D3B8" }}
              >
                <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
              </svg>
              <p className="text-sm text-accent-footerText">
                {siteContent.footer.contactInfo.email}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="border-t border-accent-footerText/30">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-wrap justify-center items-center gap-x-2 sm:gap-x-3 gap-y-1">
            <p className="text-[10px] sm:text-xs text-accent-footerText whitespace-nowrap">
              ©2026 Paalana. All Right Reserved
            </p>
            <span className="hidden sm:inline text-accent-footerText text-[10px] sm:text-xs whitespace-nowrap">
              |
            </span>
            <Link
              to={siteContent.footer.legal.links[0].path}
              onClick={handleFooterNavigate}
              className="text-[10px] sm:text-xs text-accent-footerText hover:opacity-80 transition-opacity duration-200 whitespace-nowrap"
            >
              {siteContent.footer.legal.links[0].label}
            </Link>
            <span className="hidden sm:inline text-accent-footerText text-[10px] sm:text-xs whitespace-nowrap">
              |
            </span>
            <Link
              to={siteContent.footer.legal.links[1].path}
              onClick={handleFooterNavigate}
              className="text-[10px] sm:text-xs text-accent-footerText hover:opacity-80 transition-opacity duration-200 whitespace-nowrap"
            >
              {siteContent.footer.legal.links[1].label}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

